import { FileMeta } from '@tsq-web/files';

export class TSqFeatureDetails {
  id?: string;
  title: string;
  description: string;
  creationDate: string;
  attachments: FileMeta[];
}
